<!--站点一览列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">批量绑定收款人与设备</span>
      </div>
      <div class="right">
        <Button @click="$router.back()">取消</Button>
        <Button v-preventReClick type="primary" @click="save" style="margin-left: 20px">确认绑定</Button>
      </div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
      <span>1、设备与收款人关联后，即代表你同意将此设备的收益，按所设定的比例支付给此收款人；款项划拨后不可逆转，请谨慎操作！<br />
        <span
          style="margin-left: 60px">2、如果所选设备已关联收款人，哪么本次操作将覆盖并替换之前关联的收款人</span>
      </span>
    </div>
    <div style="padding: 20px">
      <div class="item_title">
        <Button type="primary" @click="addAccount">添加收款人</Button>
      </div>
      <div v-if="data.accounts.length==0" style="font-size: 14px;color: black;">请点击上方按钮添加收款人</div>
      <div style="margin-top: 20px" v-for="(it, index) in data.accounts" :key="index">
        <span class="name">收款人{{ index + 1 }}:</span>
        <Select v-model="it.id" class="select" style="width: 280px" placeholder="只能选择‘完成配置’的收款人" @on-change="selectChange">
          <Option v-for="(item, index) in accounts" style="text-align: left" :key="index"
             :disabled="!item.user_id || item.status != 1"
             :value="item.id">ID:{{ item.id }}&nbsp;&nbsp;{{ item.name
            }}{{ !item.user_id || item.status != 1 ? "(未配置)" : "" }}</Option>
        </Select>

        <span class="name" style="margin-left: 20px;margin-right: 6px;">分账比例:</span>
        <Input placeholder="如分账比例是100%，则填入数字“100”" v-model="it.extract" :min="1" :max="100" maxlength="3" type="number"
          number style="width: 280px;">
        </Input>
        <span class="name" style="margin-left: 5px;">%</span>
        <Button type="error" style="margin-left: 20px;" @click="deleteAccount(index)">删除</Button>
      </div>

      <div class="item_title" style="margin-top: 100px;margin-bottom: 0;">
        <Button type="primary" @click="addAssignMachine">指定设备</Button>
      </div>
    </div>

    <div>
      <Table :columns="columns" :data="list">
        <template slot-scope="{ row }" slot="status">
          <span>{{
            row.software_version === row.software_version_after
            ? "成功"
            : "待更新"
          }}</span>
        </template>
      </Table>
    <!-- <div class="t-right" style="margin-top: 20px">
          <Page
            @on-change="pageChange"
            @on-page-size-change="sizeChange"
            :current="page.p + 1"
            :total="total"
            :page-size="10"
            show-elevator
            show-sizer
            show-total
          />
                  </div> -->
    </div>

    <Modal v-model="modal.visible" title="指定设备" :width="1100" footer-hide :closable="false">
      <div>
        <div class="filter-box">
          <div>
            <span class="subtitle">设备序列号:</span>
            <Input v-model="search.sn" placeholder="请输入设备序列号" style="width: 160px; margin: 0 10px" />
            <span class="subtitle">设备站点:</span>
            <Select v-model="search.site_id" class="item" filterable style="width: 230px; margin: 0 10px"
              placeholder="请选择">
              <Option v-for="(item, index) in siteList" :key="index" :value="item.id">{{ item.name }}</Option>
            </Select>
            <!-- <span class="subtitle">合作伙伴:</span>
            <Select v-model="search.agent_id" class="item" filterable style="width: 230px; margin-left: 5px"
              placeholder="请选择">
              <Option v-for="(item, index) in agentList" :key="index" :value="item.id">{{ item.agent_name }}</Option>
            </Select> -->

            <Button type="primary" @click="getMachine()">筛选</Button>
            <Button style="margin-left: 10px;" @click="reset">清空</Button>
            <Button style="margin-left: 10px" @click="selectAll(isMachineAll)">{{ isMachineAll ? "取消全选"
              : "全选设备" }}</Button>
          </div>
          <div class="bottom">
            <Button v-preventReClick type="primary" @click="saveAddMachine">确定</Button>
            <Button @click="cancelAdd"  style="margin-left: 10px">取消</Button>
          </div>
        </div>
        <Table :columns="machine_columns" :data="machine" ref="selection" @on-selection-change="selectTable">
          <template slot-scope="{ row }" slot="status">
            <span>{{ status[row.status].name }}</span>
          </template>
        </Table>
        <div class="t-left" style="margin-top: 20px">
          <Page @on-change="mpageChange" @on-page-size-change="msizeChange" :current="search.p + 1" :total="machineTotal"
            :page-size="10" show-elevator show-sizer show-total />
        </div>
        <!-- <div style="margin: 20px 0;text-align: right;">

        </div> -->
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import config from '@/config'

export default {
  data () {
    return {
      data: {
        accounts: []
      },
      accounts: [],
      loading: false,
      baseUrl: '',
      list: [],
      columns: [
        { title: '序列号', key: 'sn', width: '150' },
        { title: '设备站点', key: 'site_name' },
        { title: '合作伙伴', key: 'agent_name' },
        { title: '设备型号', key: 'machine_type_name', width: '150' },
        { title: '地址', key: 'address' },
        {
          title: '操作',
          key: 'operate',
          width: '200',
          render: (h, data) => {
            return h(
              'Button',
              {
                props: {
                  size: 'small',
                  type: 'error'
                },
                on: {
                  click: () => {
                    this.delete(data.row, data.index)
                  }
                }
              },
              '删除'
            )
          }
        }
      ],
      page: {
        p: 0,
        l: 1000
      },
      total: 0,
      modal: {
        visible: false,
        data: {
          sns: []
        }
      },
      agentList: [],
      siteList: [],
      search: {
        p: 0,
        l: 10,
        sn: '',
        site_id: '',
        agent_id: 0,
        isAll: true
      },
      machineTotal: 0,
      machine: [], // 分页设备列表
      machineAllList: [], // 所有设备列表
      machineList: [], // 所有设备列表
      isMachineAll: false, // 是否全选设备列表
      isExcept: false,
      machine_columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '站点',
          width: 160,
          key: 'site_name'
        },
        {
          title: '序列号',
          width: 120,
          key: 'sn'
        },
        {
          title: '设备型号',
          minWidth: 100,
          key: 'machine_type_name',
          show: true
        },
        {
          title: '合作伙伴',
          minWidth: 140,
          key: 'agent_name',
          show: true
        },
        {
          title: '地址',
          minWidth: 260,
          key: 'address',
          show: true,
          tooltip: true,
          render: (h, data) => {
            return [h('span', {}, data.row.province + data.row.city + data.row.area + data.row.address + data.row.address_detail)]
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'GetPayee',
      'BatchDispense',
      'GetMachineListData',
      'getSite',
      'getAgentList'
    ]),
    getData () {
      this.GetPayee({ p: 0, l: 10000 }).then((res) => {
        this.accounts = res.data
      })
    },
    addAccount () {
      if (this.data.accounts.length == 5) {
        this.$Message.error({
          content: `收款人最多只能添加5个`,
          duration: 2
        })
        return
      }
      this.data.accounts.push({ id: 0, extract: '' })
    },
    deleteAccount (index) {
      this.data.accounts.splice(index, 1)
    },
    selectChange (val) {
      console.log('选择', val)
    },
    save () {
      let isVerify = true
      let extract = 0, ids = []
      this.data.accounts.map(item => {
        if (!item.id || !item.extract) {
          isVerify = false
        }
        ids.push(item.id)
        extract += item.extract
      })
      if (!isVerify) {
        this.$Message.error({
          content: `请选择收款人和设置分账比例`,
          duration: 2
        })
        return
      }
      if (ids.length !== new Set(ids).size) {
        this.$Message.error({
          content: `收款人不能重复!`,
          duration: 2
        })
        return
      }
      if (extract != 100) {
        this.$Message.error({
          content: `所有收款人的分账比例总和必须为100%`,
          duration: 2
        })
        return
      }
      if (this.list.length == 0) {
        this.$Message.error({
          content: `请指定设备!`,
          duration: 2
        })
        return
      }

      ids = []
      console.log('设备', this.list)
      this.list.map((item) => {
        ids.push(item.id)
      })
      this.data.ids = ids
      console.log('请求数据', this.data)
      this.BatchDispense(this.data).then((res) => {
        this.$Message[res.status ? 'success' : 'error'](res.msg)
        if (res.status) {
          this.$router.back()
        }
      })
    },

    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    staffChange () {
      this.getData()
    },
    msizeChange (l) {
      this.search.l = l
      this.getMachine(true)
    },
    mpageChange (p) {
      this.search.p = p - 1
      this.getMachine(true)
    },

    // 重置获取数据
    reset () {
      this.modal.data.sns = []
      this.search = {
        p: 0,
        l: 10,
        sn: '',
        site_id: '',
        agent_id: this.user.tp ? this.user.id : '',
        isAll: true
      }
      this.getMachine()
    },
    onSelectName (index) {
      this.version = []
      this.data.version = ''
      this.software.map((item) => {
        if (this.data.name == item.name) {
          this.version = item.versions
          console.log('软件版本', this.version)
        }
      })
    },
    versionCreate (val) {
      this.version.unshift(val)
    },
    addAssignMachine () {
      this.modal.visible = true
      this.search = {
        p: 0,
        l: 10,
        sn: '',
        site_id: '',
        agent_id: this.user.tp ? this.user.id : '',
        isAll: true
      }
      this.isMachineAll = false
      this.GetMachineListData(this.search).then((res) => {
        this.machineList = res.data
        this.machineAllList = res.data
        this.machine = []
        this.machineTotal = res.total

        this.machineList.map((item, index) => {
          if (index < this.search.l) {
            this.machine.push(item)
          }
          // 设置已选择的设备
          this.modal.data.sns.map(it => {
            if (item.id === it.id) {
              item._checked = true
            }
          })
        })
        console.log('所有设备', this.machineList.length)
      })
      this.getSite({ p: 0, l: 1000 }).then((res) => {
        this.siteList = res.data
      })
    },
    getMachine (isPage) {
      if (!isPage) {
        this.GetMachineListData(this.search).then((res) => {
          this.machineList = res.data
          this.machine = []
          this.machineTotal = res.total
          this.machineList.map((item, index) => {
            if (index < this.search.l) {
              this.machine.push(item)
            }
            // 设置已选择的设备
            this.modal.data.sns.map(it => {
              if (item.id === it.id) {
                item._checked = true
              }
            })
          })
        })
      }
      this.machine = this.machineList.slice(
        this.search.p * this.search.l,
        (this.search.p + 1) * this.search.l
      )
      // 设置全选状态
      this.machine.map((item) => {
        item._checked = this.isMachineAll
        this.modal.data.sns.map(it => {
          if (item.id === it.id) {
            item._checked = true
          }
        })
      })
    },
    delete (data, index) {
      this.list.splice(index, 1)
      let sns = this.data.sns.split(',')
      sns = sns.filter(function (item) {
        return item != data.sn
      })
      this.data.sns = sns.join(',')
      this.modal.data.sns.splice(index, 1)
    },
    selectTable (data) {
      let select = this.modal.data.sns
      if (data.length > 0) {
        let json = select.concat(data)
        let newJson = []
        for (const item1 of json) {
          let flag = true // 建立标记，判断数据是否重复，true为不重复
          for (const item2 of newJson) {
            if (item1.id == item2.id) {
              flag = false
            }
          }
          if (flag) {
            // 判断是否重复
            newJson.push(item1)
          }
        }
        select = newJson
      } else {
        let temp = [...select].filter(x => [...this.machine].every(y => y.id !== x.id))
        select = temp
      }
      console.log('选择的', select)
      this.modal.data.sns = select
    },
    saveAddMachine () {
      if (this.modal.data.sns.length == 0) {
        this.$Message.error('请选择设备')
        return
      }
      this.modal.visible = false
      // let sns = this.data.sns ? this.data.sns.split(",") : [];
      let snArray = [],
        selectList = []
      this.modal.data.sns.map((item) => {
        selectList.push({
          id: item.id,
          sn: item.sn,
          site_name: item.site_name,
          agent_name: item.agent_name,
          machine_type_name: item.machine_type_name,
          address: item.province + item.city + item.area + item.address + item.address_detail
        })
      })
      let newlist = this.list.concat(selectList)
      let newJson = []
      newlist.map((item) => {
        let flag = true
        newJson.map((item2) => {
          if (item.sn == item2.sn) {
            flag = false
          }
        })
        if (flag) {
          snArray.push(item.sn)
          newJson.push(item)
        }
      })
      this.list = newJson
      this.total = snArray.length
      this.data.sns = snArray.join(',')
    },
    selectAll (isAll) {
      this.isMachineAll = !isAll
      this.$refs.selection.selectAll(this.isMachineAll)
      this.modal.data.sns = this.isMachineAll ? this.machineList : []
    },
    cancelAdd () {
      this.modal.data.sns = []
      this.modal.visible = false
    }
  },
  mounted () {
    let params = this.$route.params.data
    if (params) {
      this.data = JSON.parse(params)
      this.upload.apk.push({ name: 'release.apk', url: this.data.apk })
    }
    this.getData()
    this.getAgentList({ p: 0, l: 1000, is_del: 0 }).then((res) => {
      this.agentList = res.data
    })
  },
  created () {
    this.baseUrl =
      process.env.NODE_ENV === 'development'
        ? config.baseUrl.dev
        : config.baseUrl.pro
  },
  computed: mapGetters({
    user: 'agent',
    access: 'access'
  })
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
